import { ref,onMounted,getCurrentInstance,onUnmounted, nextTick,computed} from "vue";
import { isEmpty} from "@/utils/type";
import { useRoute } from "vue-router";
import { message  } from "ant-design-vue";
export default function change(data:any){
  const $bus = getCurrentInstance()?.appContext.config.globalProperties.$bus
  const route = useRoute();
  const { traceId } = route.query;
 
  const proxy = getCurrentInstance()?.proxy
 
  
  //表单提交
  const handleOk =async(type:boolean)=>{
    nextTick(()=>{
      let ref = data.FormRef
      const param = JSON.parse(JSON.stringify(data.FormData))
      if(data.nodeIdx == 6 ){//资料用印是否补充上传 true是
        if(type){
          ref = data.formRef5
          param.PageFiles = [...data.form5.PageFiles,...data.FormData.PageFiles]
        }else{
          param.PageFiles = [...data.PostFiles.PageFiles,...data.FormData.PageFiles]
        }
        param.IsSupplement = type
      }
      ref.validate().then(async()=>{
        param.BranchCompanyFlowId = data.props.BranchCompanyFlowId
        param.TraceId = traceId
        if(data.nodeIdx == 3){//地址变更 回传完成后进行非必要文件上传带着回传文件
          param.PageFiles = [...data.turnDecpro.PageFiles,...data.FormData.PageFiles]
        }
        const { Data, Success, Message } = await data.ApplyApi(param);
        if (Success) {
          if(data.nodeIdx != 1){//除了地址变更
            getDetail(Data)
          }
          $bus.emit('getId',Data)
        } else {
          message.warning(Message);
        }
        isShowModel.value = false
      }).catch((rep:any)=>{
        ref.scrollToField(rep.errorFields[0].name)
      })
    })
    
  }

  //获取详情
  const form = ref();
  const actionButtons = ref<(string | number)[]>([]); //默认是申请审批
  const edit = computed(() => actionButtons.value.includes("100") || actionButtons.value.includes("-2") ) ;
  
  const getDetail = async (id:number)=>{
    const { Data,Success ,Message} = await data.DetailApi({
      Id: id,
      TraceId:traceId,
    });
    if(Success){
      if(Data){
        actionButtons.value = Data.ActionButtons;
        data.FormData.PageFiles = Data.PageFiles
        form.value = data.FormData

        if(data.nodeIdx == 8){//印章刻制
          data.FormData.Seals = Data.Seals
        }
        if(data.nodeIdx == 1){//地址变更
          data.FormData.PageData = Data.PageData
          
          // 时间处理

          isEmpty(Data.PageData.RentStartTimeOld)?[]:data.FormData.PageData.RentTimeOld = [Data.PageData.RentStartTimeOld,Data.PageData.RentEndTimeOld]
          isEmpty(Data.PageData.RentStartTimeNew)?[]:data.FormData.PageData.RentTimeNew = [Data.PageData.RentStartTimeNew,Data.PageData.RentEndTimeNew]
          // 地区处理
          data.FormData.PageData.cityNewName =''
          data.FormData.PageData.cityNew = []
          if(!isEmpty(data.FormData.PageData.DistrictCodeNew)){
            if(data.FormData.PageData.ProvinceCodeNew == data.FormData.PageData.CityCodeNew){
              data.FormData.PageData.cityNew = [data.FormData.PageData.CityCodeNew,data.FormData.PageData.DistrictCodeNew]
              data.FormData.PageData.cityNewName = data.FormData.PageData.CityNameNew + data.FormData.PageData.DistrictNameNew
            }else{
              data.FormData.PageData.cityNew = [data.FormData.PageData.ProvinceCodeNew,data.FormData.PageData.CityCodeNew,data.FormData.PageData.DistrictCodeNew]
              data.FormData.PageData.cityNewName = data.FormData.PageData.ProvinceNameNew + data.FormData.PageData.CityNameNew + data.FormData.PageData.DistrictNameNew
            }
          }
          
          data.FormData.PageData.cityOldName =''
          data.FormData.PageData.cityOld = []
          if(!isEmpty(data.FormData.PageData.DistrictCodeOld)){
            if(data.FormData.PageData.ProvinceCodeOld == data.FormData.PageData.CityCodeOld){
              data.FormData.PageData.cityOld = [data.FormData.PageData.CityCodeOld,data.FormData.PageData.DistrictCodeOld]
              data.FormData.PageData.cityOldName = data.FormData.PageData.CityNameOld + data.FormData.PageData.DistrictNameOld
            }else{
              data.FormData.PageData.cityOld = [data.FormData.PageData.ProvinceCodeOld,data.FormData.PageData.CityCodeOld,data.FormData.PageData.DistrictCodeOld]
              data.FormData.PageData.cityOldName = data.FormData.PageData.ProvinceNameOld + data.FormData.PageData.CityNameOld + data.FormData.PageData.DistrictNameOld
            }
          }
        }

        if(data.nodeIdx == 3 || data.nodeIdx ==4){//3房屋租赁 4装修采购
          data.turnDecpro.PageFiles = Data?.BackPageFiles
          const _list = Data?.PageFiles.slice();
          if(data.nodeIdx == 3){ //房屋租赁
            data.FormData.PageData.ContactMobile =  Data.RentContactMobile
            data.FormData.PageData.BankAccount = Data.RentBankAccount
            data.isEditFile = Data.IsEdit;
            data.IsSQWTEdit = Data.IsSQWTEdit;
            data.IsZLBAEdit = Data.IsZLBAEdit;
            data.IsWYXYEdit = Data.IsWYXYEdit
            
            _list[2] = setPageList('911',2)
            _list[3] = setPageList('912',3)
            _list[4] = setPageList('913',4)
          }else{
            _list[0] = setPageList('921',0)
            _list[1] = setPageList('922',1)

            data.IsFWZXEdit = Data.IsFWZXEdit
            data.IsBGCGEdit = Data.IsBGCGEdit
          }

          data.FormData.PageFiles = _list
        }

        if(data.nodeIdx == 6){//资料用印
          data.PostFiles.PageFiles = Data?.PostFiles;
          data.IsEdit = Data.IsEdit
          data.IsBcEdit = Data.IsBcEdit
          data.IsGDRMSEdit = Data.IsGDRMSEdit
        }
        if(data.nodeIdx == 7){//税务迁址
          const _list = Data?.PageFiles.slice();
          _list[0] = setPageList('1311',0)
          _list[1] = setPageList('1312',1)
          data.FormData.PageFiles = _list

          data.IsQYTZSEdit = Data.IsQYTZSEdit
          data.IsSWDJEdit = Data.IsSWDJEdit
        }

        data.IsFirstEdit1 = false
        data.IsFirstEdit2 = false
        data.IsFirstEdit3 = false
        setWinHeight()
        if(!data.props.reEdit){
          proxy?.$emit("change-status", {
            buttons: Data?.ActionButtons,
            flowId: Data?.WorkFlowId,
            ApplicationInfo:Data?.ApplicationInfo,
            ApplicationTime:Data?.ApplicationTime,
          });
        }
        
      }
    }else{
      message.error(Message);
    }
    
  }

  //整理房屋租赁/装修采购图片列表
  const setPageList = (type:string,index:number)=>{
    const _list = data.FormData.PageFiles.slice();
    const _SQWT = data.FormData.PageFiles.find((item:any) => {
      return item.AccessoryType == type;
    });
    if (!_SQWT) {
      _list[index] = {
        AccessoryType: type,
        FileName: "",
        FileUrl: "",
      };
    } else {
      _list[index] = _SQWT;
    }
    return _list[index] 
  }
  
  const isShowModel = ref<boolean>(false);//补充弹窗


  // 装修采购回传
  const submitTurnaroundDecproApply = async () => {
    nextTick(()=>{
      data.turnFormRef.validate().then(async () => {
        const { Success, Message } = await data.turnApi({
          PageFiles: data.turnDecproModel.PageFiles,
          BranchCompanyFlowId: data.props.BranchCompanyFlowId,
          TraceId:traceId,
        });
        if (Success) {
          message.success("已提交回传");
        } else {
          message.error(Message || "提交失败，请稍后重试");
        }
        isShowModel.value = false;
        getDetail(data.props.BranchCompanyFlowId)
      });
    })
    
  };

  //提交页面计算高度
  const winHeight = ref(0)
  const setWinHeight = () => {
    nextTick(()=>{
      winHeight.value = edit.value ?(document.querySelector('.side-box')as Element).getBoundingClientRect().height - 304:0;
    })
  }

  const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
  onMounted(async() => {
    await getDetail(data.props.BranchCompanyFlowId)
    $bus.on('click', (type:number) => {//申请审批100/提交-2/装修采购/房屋租赁审批后上传资料-3
      if(type == 100 || type== -2 || type== -3){
        handleOk(false)
      }else if(type == 601 || type ==401 ||type==501){//601资料用印补充,401房屋回传,501装修回传
        isShowModel.value = true;
      }else if(type ==102){//重新发起
        preButton.value  = actionButtons.value
        actionButtons.value=['-1','-2']
        setWinHeight()
      }else if(type == -1){//返回
        actionButtons.value = preButton.value 
        setWinHeight()
      }
    })
    $bus.on('getDetail',(id:number)=>{
      getDetail(id)
    })
  });

  onUnmounted(()=>{
    $bus.off('click')
    $bus.off('getDetail')
    
  })

  return {
    form,
    actionButtons,
    getDetail,
    edit,
    isShowModel,
    handleOk,
    submitTurnaroundDecproApply,
    winHeight,
    traceId,
  }
}
